"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lang = {
  locale: 'zh-cn',
  pagination: {
    prev: '上一页',
    next: '下一页',
    jumpPrev: '向前 {jumpPrev} 页',
    jumpNext: '向后 {jumpNext} 页',
    sizeUnit: '条/页',
    jumpTo: '前往',
    total: '共 {total} 条'
  },
  datepicker: {
    selectDate: '选择日期',
    selectTime: '选择时间',
    startTime: '开始时间',
    endTime: '结束时间',
    now: '此刻',
    cancel: '取消',
    ok: '确定',
    datePanelLabel: '[yyyy年] [M]',
    year: '年',
    month: '月',
    date: '日',
    hour: '时',
    minute: '分',
    second: '秒',
    am: '上午',
    pm: '下午',
    week: '周',
    thisWeek: '本周',
    today: '今天',
    weekStart: 1,
    monthBeforeYear: false,
    selectFirst: 'year',
    // 第一个选项
    nowBtnText: {
      datetime: '此刻',
      date: '今天',
      year: '本年',
      month: '本月',
      week: '本周',
      quarter: '本季度',
      halfyear: '本半年度'
    },
    weeks: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    },
    months: {
      m1: '1月',
      m2: '2月',
      m3: '3月',
      m4: '4月',
      m5: '5月',
      m6: '6月',
      m7: '7月',
      m8: '8月',
      m9: '9月',
      m10: '10月',
      m11: '11月',
      m12: '12月'
    }
  },
  popconfirm: {
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  },
  confirm: {
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  },
  modal: {
    okText: '确定',
    cancelText: '取消',
    justOkText: '我知道了',
    tip: '提示'
  },
  transfer: {
    noMatch: '暂无搜索数据',
    noData: '暂无数据',
    itemsUnit: '项',
    searchPlaceholder: '请输入',
    clearAll: '清空全部',
    total: '已选 {total} 项'
  },
  dragSelect: {
    noMatch: '搜索结果为空',
    searchPlaceholder: '请输入过滤条件'
  },
  table: {
    filterConfirm: '确定',
    filterReset: '重置',
    emptyText: '暂无数据',
    searchPlaceholder: '请输入关键字',
    loadingText: '加载中',
    ascend: '点击升序',
    descend: '点击降序',
    cancelSort: '取消排序'
  },
  picker: {
    placeholder: '请选择',
    noMatch: '暂无搜索结果',
    noData: '暂无数据',
    loading: '搜索中',
    total: '共 {total} 项'
  },
  cascader: {
    placeholder: '请选择',
    noMatch: '暂无搜索结果',
    loading: '加载中',
    noData: '暂无数据'
  },
  loading: {
    message: '加载中...'
  },
  select: {
    placeholder: '请选择',
    filterablePlaceholder: '请输入'
  },
  upload: {
    uploadError: '上传错误',
    uploadFile: '上传文件',
    uploadImage: '上传图片'
  },
  tree: {
    placeholder: '请选择',
    emptyText: '暂无数据'
  },
  autoComplete: {
    placeholder: '请输入',
    emptyText: '暂无数据',
    loading: '搜索中'
  },
  empty: {
    title: '暂无数据'
  },
  filelist: {
    uploading: '上传中'
  },
  image: {
    loadError: '加载失败',
    reload: '点击重试',
    preview: '预览',
    originSize: '原始尺寸',
    responsive: '自适应尺寸'
  },
  inputNumber: {
    limit: '限制范围'
  },
  card: {
    loading: '加载中...'
  },
  textarea: {
    showCount: '共 {showCount} 个字'
  },
  colorPicker: {
    presetEmpty: '暂无',
    transparent: '无色',
    singleColor: '单色',
    gradientColor: '渐变色',
    presetsLabel: '系统预设颜色',
    recentLabel: '最近使用颜色'
  }
};
var _default = exports.default = lang;